import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private readonly messageSubject = new BehaviorSubject<string | null>(null);
  private requestCount = 0;

  readonly loading$ = this.loadingSubject.asObservable();
  readonly message$ = this.messageSubject.asObservable();

  setMessage(message: string | null): void {
    this.messageSubject.next(message);
  }

  show(): void {
    this.requestCount += 1;

    if (this.requestCount === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide(): void {
    this.requestCount = Math.max(0, this.requestCount - 1);

    if (this.requestCount === 0) {
      this.loadingSubject.next(false);
    }
  }

  get isLoading(): boolean {
    return this.loadingSubject.value;
  }
}
